import http from '@/biz/http.mjs'

export default {

    push: (data) => http.post('/prjkms/batchmodify', data),
    read: ({pkid}) => http.get(`/prjkms/${pkid}`),
    updateMap: (data) => http.put(`/prjkms/${data.pkid}/map`, data),
}
